import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../../components/Charts/BarChart';
import ChartFilter from '../../../../components/Charts/ChartFilter/ChartFilter';
import RatingMetricsLegend from '../../../../components/Charts/CustomLegends/RatingMetricsLegend';
import RatingMetricTooltip from '../../../../components/Charts/CustomToolTips/RatingMetricTooltip';
import useRatingInsight from '../../../../hooks/dashboard/driver-list/useRatingInsight';
// import { RAW_DATA } from './data';

const RatingMetrics = ({ baseUrl }: { baseUrl: string }) => {
  const [dataUrl, setDataUrl] = useState<string>(baseUrl);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 884);

  const { getRatingDataInsight, ratingInsightData } = useRatingInsight();

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 884);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!dataUrl) return;
    getRatingDataInsight(dataUrl);

    // eslint-disable-next-line
  }, [dataUrl]);

  const colorObj: Record<string, string> = {
    '1': '#F87171',
    '2': '#FB923C',
    '3': '#FBBF24',
    '4': '#A3E635',
    '5': '#4ade80',
  };

  return (
    <Container>
      <HeaderArea>
        <Header>Rating Metrics</Header>

        <ControlArea>
          <ChartFilter setDataUrl={setDataUrl} dataUrl={dataUrl} />
        </ControlArea>
      </HeaderArea>

      <ChartArea>
        <BarChart
          xAxisDataKey='period'
          data={ratingInsightData}
          // data={RAW_DATA}
          isAnimationActive={true}
          dataKeys={['noOfRatings']}
          // fills={RAW_DATA.map((data) => data.ratingColor)}
          fills={ratingInsightData.map((data) => data.ratingColor)}
          showLegend={false}
          aspect={isMobile ? 1.5 : 3}
          minHeight={isMobile ? 220 : undefined}
          tooltipLabel={['Rating Metrics']}
          externalTooltip={{
            content: <RatingMetricTooltip tooltipLabel={['Driver Rating']} />,
            cursor: { fill: 'rgba(0, 0, 0, 0.05)' },
          }}
          yLabel='Rating volume'
          isCategorical={true}
          // xLabel='No of days in the month'
        />
      </ChartArea>
      <RatingMetricsLegend
        colorObj={colorObj}
        label='No of days in the month'
      />
    </Container>
  );
};

export default RatingMetrics;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
`;

const ChartArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;

const ControlArea = styled.div`
  display: flex;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 18px;

  @media (max-width: 884px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
